import { atom } from 'jotai';

// Controls visibility of the offline-JP modal. Auto-opened on mount when the
// JP is offline; the inline trigger below the disabled "Candidati" button
// re-opens it after the user dismisses.
export const offlineJpModalOpenAtom = atom<boolean>(false);
